"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const window_or_global_1 = __importDefault(require("window-or-global"));
function default_1() {
    /**
     * Enum for URLs for the API endpoints.
     */
    let appContext = '';
    if (window_or_global_1.default.appContext && window_or_global_1.default.appContext !== '/') {
        appContext = window_or_global_1.default.appContext; //eslint-disable-line
    }
    if (!window_or_global_1.default.location.origin) {
        const port = window_or_global_1.default.location.port ? `:${window_or_global_1.default.location.port}` : '';
        window_or_global_1.default.location.origin = `${window_or_global_1.default.location.protocol}//${window_or_global_1.default.location.hostname}${port}`;
    }
    const origin = window_or_global_1.default.apiHost && window_or_global_1.default.apiHost.indexOf('undefined') ? window_or_global_1.default.apiHost : window_or_global_1.default.location.origin + appContext;
    const URL = {
        INVITE: {
            GETINVITES: `${origin}/api/invite`,
            SENDINVITE: `${origin}/api/sendInvite`
        },
        REDEEM: {
            VALIDATE: `${origin}/ajax/redemption/validate-redemption-code`,
            SUBMIT: `${origin}/ajax/redemption/submit-redemption-code`,
            CLEARENTITLEMENTS: `${origin}/api/redeem/clear`
        },
        POSA: {
            GET_CMS_CONTENT(locale) {
                return `${origin}/${locale}/api/posa/content`;
            },
            GET_CARD_STATUS(locale) {
                return `${origin}/${locale}/api/posa/code/status`;
            },
            REDEEM_CARD(locale) {
                return `${origin}/${locale}/api/posa/code/redeem`;
            }
        }
    };
    return URL;
}
exports.default = default_1;
//# sourceMappingURL=Url.js.map